import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TLayoutMobile, IDepsMobile } from '../models';

import { Layout as Component } from './mobile';
import styles from './mobile.css';

export const LayoutMobile = createWidget<IDepsMobile, TLayoutMobile>({ styles })(Component);
